<template>
  <div class="animated fadeIn">
    <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
      <div slot="header">
        <i class="icon-note"></i> Rute Konsumen Non GT
      </div>

      <b-card-body>
        <b-row>
          <b-col sm="3">
            <b-form-group label-for="route_id" label="Rute Konsumen">
              <b-form-input
                id="name"
                type="text"
                v-model="routeDetail.name"
                readonly
                placeholder="Rute Konsumen"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
      <div slot="footer" class="text-right">
        <b-button type="button" size="sm" variant="danger" @click="back">
          <i class="fa fa-undo"></i> Back
        </b-button>&nbsp;
      </div>
    </b-card>

    <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
      <b-tabs>
        <b-tab title="Konsumen" active>
          <global-table
            :table-data="customer_route_non_gt"
            :loading="loading"
            :per-page="10"
            :bordered="true"
            :table-detail="tableDetail"
            :hover="true"
            :striped="false"
            :fields="fields"
            :row-edit="routeNonGTDetailForm"
            :redirect-detail="false"
            :show-add-button="true"
            :edit-button="false"
            :remove-button="true"
            :id-modals="'routeNonGTDetailForm'"
            caption="<i class='fa fa-align-justify'></i> Customer Rute Non GT Listing"
            addButton="Tambah Rute Konsumen Non GT"
            @removeForm="removeForm"
            @resetForm="resetForm"
          ></global-table>

          <b-modal
            ref="routeNonGTDetailForm"
            id="routeNonGTDetailForm"
            header-border-variant="no-border text-center"
            footer-border-variant="no-border"
            footer-bg-variant="light"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            size="lg"
          >
            <div slot="modal-header" class="text-center">
              <h3 class="text-center">Pointing rute dengan konsumen</h3>
            </div>

            <b-form id="routeNonGTDetailForm" validated novalidate>
              <b-row>
                <b-col sm="4">
                  <b-form-group label-for="customer_id" label="Konsumen">
                    <model-select
                      id="customer_id"
                      :options="listCustomerIndomaret"
                      v-model="$v.routeNonGTDetailForm.customer_id.$model"
                      :isError="$v.routeNonGTDetailForm.customer_id.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="routeNonGTDetailForm.customer_id === null"
                      class="invalid-feedback-custom"
                    >Konsumen harus di pilih.</div>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>

            <div slot="modal-footer" class="float-right">
              <b-button type="button" size="sm" variant="danger" @click="cancelPointingCustomer">
                <i class="fa fa-undo"></i> Back
              </b-button>&nbsp;
              <b-button
                type="button"
                size="sm"
                variant="primary"
                @click="savePointingCustomer"
                :disabled="$v.routeNonGTDetailForm.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </b-modal>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect } from "vue-search-select";

export default {
  name: "route_non_gt",
  components: { globalTable, ModelSelect },
  props: {
    tableDetail: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      customer_route_non_gt: [],
      listCustomerIndomaret: [],
      loading: true,
      routeDetail: {},
      fields: [
        { key: "customer_name", label: "Nama Konsumen", sortable: true },
        { key: "action", class: "text-center width-80" }
      ],
      routeNonGTDetailForm: interfaces.route_non_gt
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  validations: {
    routeNonGTDetailForm: {
      customer_id: { required }
    }
  },
  methods: {
    init: function(route_id) {
      this.getRouteNonGTDetail(route_id);
      this.getDropdown();
    },
    getRouteNonGTDetail: function(route_id) {
      this.axios
        .get("web/customer/detail-route-non-gt/" + route_id + "/")
        .then(response => {
          this.routeDetail = response.data.data;
          this.customer_route_non_gt = response.data.all_related_customer;
        })
        .catch(error => {
          this.expired(error, "Rute Non GT");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdown: function() {
      this.axios
        .get("web/dropdown/route-non-gt/")
        .then(response => {
          this.listCustomerIndomaret = response.data.customer_indomaret;
        })
        .catch(error => {
          this.expired(error, "Rute Dropdown Non GT");
        })
        .finally(() => {});
    },
    removeForm: function(data) {
      if (confirm("Apakah anda ingin menghapus asset konsumen ini ?")) {
        let route = this.$route.path.split("/");
        let route_non_gt = data;
        this.axios
          .delete("web/customer/remove-customer-route-non-gt/" + data.id)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Hapus rute konsumen",
                message: response.data.message
              });
            }
          })
          .catch(error => {
            this.expired(error, "Hapus rute konsumen");
          })
          .finally(() => {
            this.init(route[4]);
          });
      }
    },
    resetForm: function() {
      for (var a in interfaces.route_non_gt) {
        interfaces.route_non_gt[a] = null;
      }
      this.routeNonGTDetailForm = interfaces.route_non_gt;
    },
    back: function() {
      this.$router.go(-1);
    },
    cancelPointingCustomer: function() {
      this.resetForm();
      this.$refs.routeNonGTDetailForm.hide();
    },
    savePointingCustomer: function(evt) {
      if (confirm("Apakah anda ingin menambahkan konsumen ini ?")) {
        let route = this.$route.path.split("/");
        let route_non_gt = this.routeNonGTDetailForm;
        route_non_gt.route_id = route[4];
        this.axios
          .post("web/customer/add-customer-route-non-gt/", route_non_gt)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Tambah Rute Konsumen Berhasil",
                message: response.data.message
              });
            } else {
              this.showErrorNotification({
                title: "Tambah Rute Konsumen Gagal",
                message: response.data.message
              });
            }
            this.cancelPointingCustomer();
          })
          .catch(error => {
            this.expired(error, "Hapus asset");
          })
          .finally(() => {
            this.init(route[4]);
          });
      }
    },
    reload(cust_id) {
      this.$emit("reload", cust_id);
    }
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  }
};
</script>

<style>
</style>
